module.exports = __webpack_public_path__ + "1b79fc48708b1ee63aa45cb985040ad1.png";